export interface VersionChange {
  category: string;
  items: string[];
}

export interface GameVersion {
  version: string;
  name: string;
  date: string;
  cover: string;
  summary: string;
  highlights: string[];
  changes: VersionChange[];
  recommendedIds: string[];
}

export const versionList: GameVersion[] = [
  {
    version: '6.2',
    name: '霜夜与誓约',
    date: '2026-10-10',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20fantasy%20snowy%20northern%20city%20at%20night%20with%20glowing%20lanterns%20tall%20white%20towers%20and%20warm%20orange%20light%20against%20cool%20blue%20tones%2C%20clean%20minimal%20anime%20promotional%20illustration&width=800&height=500&seq=news-6201&orientation=landscape',
    summary:
      '开放至冬国首个大型区域「白匣城」，新增五星冰系角色白枢、新世界任务「霜夜的誓约」与全新秘境挑战。',
    highlights: ['至冬国新区域「白匣城」', '全新五星冰系角色「白枢」', '新周本「霜烬之匣」', '尘歌壶雪原主题家具'],
    changes: [
      {
        category: '新内容',
        items: [
          '开放新区域「白匣城」，包含地脉异常与限时挑战',
          '新增世界任务系列「霜夜的誓约」共 5 幕',
          '新增圣遗物秘境「曜金之诗」',
          '新增角色「白枢」与四星角色「雪羚」',
        ],
      },
      {
        category: '系统调整',
        items: ['优化背包筛选与材料追踪功能', '调整部分元素反应数值平衡', '提升低配置设备下的平均帧率'],
      },
      {
        category: '活动',
        items: ['开启海灯节限定活动「流光映雪」', '开启「白匣城」探索主题活动', '开启双倍经验与摩拉限时活动'],
      },
    ],
    recommendedIds: ['news-6-2-release', 'news-6-2-character', 'news-lantern-2026'],
  },
  {
    version: '6.1',
    name: '潮汐的回响',
    date: '2026-08-12',
    cover:
      'https://readdy.ai/api/search-image?query=Glowing%20legendary%20weapons%20and%20armor%20artifacts%20displayed%20on%20a%20dark%20velvet%20surface%20with%20soft%20spotlight%2C%20clean%20fantasy%20rpg%20item%20illustration&width=800&height=500&seq=news-6101&orientation=landscape',
    summary:
      '上线两把五星武器与两套新圣遗物，优化深境螺旋地脉异常，并加入多项便民系统改动。',
    highlights: ['五星长柄武器「白霜之誓」', '五星法器「潮汐回响」', '两套全新圣遗物', '深境螺旋机制优化'],
    changes: [
      {
        category: '武器',
        items: ['新增五星长柄武器「白霜之誓」', '新增五星法器「潮汐回响」', '新增若干四星武器'],
      },
      {
        category: '圣遗物',
        items: ['新增套装「曜金咏叹」：提升重击伤害', '新增套装「静水之息」：提升元素精通与生命值'],
      },
      {
        category: '玩法',
        items: ['深境螺旋更新地脉异常', '提升尘歌壶洞天仙力上限'],
      },
    ],
    recommendedIds: ['news-6-1-preview', 'news-abyss-12', 'guide-neuvilette'],
  },
  {
    version: '6.0',
    name: '至冬的序章',
    date: '2026-06-18',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20snow%20mountain%20pass%20with%20a%20lone%20figure%20and%20glowing%20blue%20aurora%20in%20the%20sky%2C%20cinematic%20wide%20anime%20game%20promotional%20illustration&width=800&height=500&seq=ver-600&orientation=landscape',
    summary:
      '6.0大版本开启至冬国主线篇章，新增纳塔后续剧情、全新地区传送点与大型地图探索内容。',
    highlights: ['至冬国主线序章开启', '全新大地图区域', '主线剧情推进', '新增飞行挑战玩法'],
    changes: [
      {
        category: '主线',
        items: ['开启至冬国主线第一章', '新增多段剧情过场动画', '新增地区声望系统内容'],
      },
      {
        category: '探索',
        items: ['新增飞行挑战与世界任务', '新增若干宝箱与解谜机关', '优化传送点指引'],
      },
      {
        category: '奖励',
        items: ['版本登录活动赠送原石与纠缠之缘', '新增成就与名片奖励'],
      },
    ],
    recommendedIds: ['news-6-1-preview', 'guide-zhongli', 'news-imaginarium'],
  },
  {
    version: '5.9',
    name: '盛夏的祭典',
    date: '2026-04-20',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20summer%20festival%20by%20the%20sea%20with%20fireworks%20and%20paper%20lanterns%2C%20warm%20vivid%20tones%2C%20clean%20anime%20game%20promotional%20illustration&width=800&height=500&seq=ver-590&orientation=landscape',
    summary:
      '夏季主题版本，开放限时海岛活动、新增趣味小游戏与大量时装奖励，适合休闲玩家体验。',
    highlights: ['限时海岛活动', '趣味小游戏合集', '大量时装与摆设奖励'],
    changes: [
      { category: '活动', items: ['开启限时海岛探索活动', '新增钓鱼大赛与料理比赛', '新增限时挑战关卡'] },
      { category: '装扮', items: ['新增多套限定时装', '尘歌壶新增夏日主题摆设'] },
      { category: '优化', items: ['优化自动寻路体验', '优化移动端操作按钮布局'] },
    ],
    recommendedIds: ['news-fishing', 'news-teapot', 'news-lantern-2026'],
  },
  {
    version: '5.8',
    name: '星穹之歌',
    date: '2026-02-25',
    cover:
      'https://readdy.ai/api/search-image?query=Starry%20night%20sky%20above%20ancient%20ruins%20with%20glowing%20constellations%20and%20a%20lone%20traveller%2C%20deep%20blue%20and%20gold%20tones%2C%20cinematic%20anime%20illustration&width=800&height=500&seq=ver-580&orientation=landscape',
    summary: '以星穹与古代遗迹为主题的版本，新增剧情章节、周本首领与天赋材料副本。',
    highlights: ['新周本「星穹守望者」', '天赋材料秘境', '剧情章节推进'],
    changes: [
      { category: '首领', items: ['新增周本首领「星穹守望者」', '调整旧周本奖励掉落'] },
      { category: '秘境', items: ['新增天赋材料秘境', '新增武器突破材料秘境'] },
      { category: '剧情', items: ['开启新剧情章节', '新增角色传说任务'] },
    ],
    recommendedIds: ['news-abyss-12', 'guide-raiden', 'news-imaginarium'],
  },
  {
    version: '5.7',
    name: '海灯映雪',
    date: '2026-01-01',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20festival%20lanterns%20floating%20over%20a%20traditional%20eastern%20water%20city%20at%20night%20with%20golden%20glow%20and%20soft%20bokeh%2C%20clean%20anime%20festival%20illustration%20art&width=800&height=500&seq=news-lantern1&orientation=landscape',
    summary: '海灯节版本，开放节日限定活动、灯谜玩法与限定兑换商店，氛围浓厚。',
    highlights: ['海灯节限定活动', '灯谜解谜玩法', '限定摆设与奖励'],
    changes: [
      { category: '活动', items: ['开启海灯节主题活动', '新增灯谜与放飞花灯玩法', '开启节日限定商店'] },
      { category: '奖励', items: ['登录赠送原石与限定摆设', '新增节日成就'] },
    ],
    recommendedIds: ['news-lantern-2026', 'news-teapot', 'guide-nahida'],
  },
];